import { Component, OnDestroy, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ReplaySubject, takeUntil } from 'rxjs';

import { LaunchDarklyFlags, WarningMessage } from 'app/core/services/launch-darkly/launch-darkly.types';
import { getFeatureFlagObservable } from 'app/core/state';
import { AppState } from 'app/types';

import { EXPERIENCE_CARDS, TutorialCard, TutorialType, TUTORIAL_CARDS } from '../room-tutorial/room-tutorial.types';
import { HelpCenterUrls } from 'app/utils/help-center';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss'],
  standalone: false,
})
export class HelpModalComponent implements OnDestroy {
  private dialogRef = inject<MatDialogRef<HelpModalComponent>>(MatDialogRef);
  private store = inject<Store<AppState>>(Store);

  public warningMessage?: WarningMessage;
  public showTutorial = false;
  public tutorialCards: TutorialCard[] = [];
  public tutorialTitle = '';
  public tutorialType: TutorialType = TutorialType.TUTORIAL;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor() {
    getFeatureFlagObservable(this.store, LaunchDarklyFlags.social_error_banner)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((warningMessage) => (this.warningMessage = warningMessage));
  }

  public closeDetail(): void {
    this.dialogRef.close('close');
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public submitTicket(): void {
    const helpCenter = HelpCenterUrls.HELP_CENTER;

    // Log ChurnZero Event Suport ticket clicked
    // this.churnZeroService.trackEvent(ChurnZeroEvent.SUPPORT);
    window.open(helpCenter, '_blank');
  }

  public goToHelpCenter(): void {
    const helpCenter = HelpCenterUrls.HELP_CENTER;

    // Log ChurnZero Event help center clicked
    // this.churnZeroService.trackEvent(ChurnZeroEvent.HELP_CENTER);
    window.open(helpCenter, '_blank');
  }

  public showTutorialView(): void {
    this.showTutorial = true;
    this.tutorialType = TutorialType.TUTORIAL;
    this.tutorialTitle = 'How to Move';
    this.tutorialCards = [...TUTORIAL_CARDS];
  }

  public showExperienceTipsView(): void {
    this.showTutorial = true;
    this.tutorialType = TutorialType.EXPERIENCE;
    this.tutorialTitle = 'Tips for a Great Experience';
    this.tutorialCards = [...EXPERIENCE_CARDS];
  }

  public onTutorialCompleted(): void {
    this.showTutorial = false;
  }
}
